// Payment storage helpers

const SAMPLE_PAYMENTS = {
  1: [
    { id: 1001, date: "2026-03-15", amount: 150, principal: 117.42, interest: 32.58, fees: 0, type: "Extra Payment", notes: "Paid extra this month" },
    { id: 1002, date: "2026-02-15", amount: 85, principal: 52.44, interest: 32.56, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 1003, date: "2026-01-15", amount: 85, principal: 51.84, interest: 33.16, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 1004, date: "2025-12-15", amount: 100, principal: 66.54, interest: 33.46, fees: 0, type: "Partial Payment", notes: "Holiday month" },
    { id: 1005, date: "2025-11-15", amount: 85, principal: 51.24, interest: 33.76, fees: 0, type: "Minimum Payment", notes: "" },
  ],
  2: [
    { id: 2001, date: "2026-03-01", amount: 210, principal: 123.58, interest: 86.42, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 2002, date: "2026-02-01", amount: 210, principal: 122.01, interest: 87.99, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 2003, date: "2026-01-01", amount: 250, principal: 162.44, interest: 87.56, fees: 0, type: "Extra Payment", notes: "New year, extra push" },
    { id: 2004, date: "2025-12-01", amount: 210, principal: 120.46, interest: 89.54, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 2005, date: "2025-11-01", amount: 210, principal: 119.90, interest: 90.10, fees: 0, type: "Minimum Payment", notes: "" },
  ],
  3: [
    { id: 3001, date: "2026-02-22", amount: 310, principal: 252.58, interest: 57.42, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 3002, date: "2026-01-22", amount: 310, principal: 251.05, interest: 58.95, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 3003, date: "2025-12-22", amount: 400, principal: 341.56, interest: 58.44, fees: 0, type: "Extra Payment", notes: "End of year bonus" },
    { id: 3004, date: "2025-11-22", amount: 310, principal: 250.12, interest: 59.88, fees: 0, type: "Minimum Payment", notes: "" },
    { id: 3005, date: "2025-10-22", amount: 310, principal: 249.60, interest: 60.40, fees: 0, type: "Minimum Payment", notes: "" },
  ],
};

export function loadPayments() {
  try {
    const saved = localStorage.getItem("elde_payments");
    if (saved) return JSON.parse(saved);
  } catch (e) {}
  return SAMPLE_PAYMENTS;
}

export function savePayments(payments) {
  try {
    localStorage.setItem("elde_payments", JSON.stringify(payments));
  } catch (e) {}
}

export function getAccountPayments(payments, accountId) {
  return payments[accountId] || [];
}

export function addPayment(payments, accountId, payment) {
  const existing = payments[accountId] || [];
  const updated = [{ ...payment, id: Date.now() }, ...existing];
  return { ...payments, [accountId]: updated };
}

export function deletePayment(payments, accountId, paymentId) {
  const existing = payments[accountId] || [];
  const updated = existing.filter(p => p.id !== paymentId);
  return { ...payments, [accountId]: updated };
}

export function getPaymentSummary(accountPayments) {
  return {
    totalPaid: accountPayments.reduce((s, p) => s + p.amount, 0),
    totalPrincipal: accountPayments.reduce((s, p) => s + (p.principal || 0), 0),
    totalInterest: accountPayments.reduce((s, p) => s + (p.interest || 0), 0),
    count: accountPayments.length,
  };
}
